import { Component, EventEmitter, OnInit } from '@angular/core';
import { DwButtonConfig, DwModalResult, DwButtonCommand, DwModalHandler, DwModalConfig, DwMessage, DwMessageSeverity, DwMetaDataRoutingService, DwMenuActionType } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { SubscriptionChangeStartResult } from '../../models/subscriptions/subscription-change-start-result.model';
import { SubscriptionChangeUIActions } from '../../models/subscriptions/subscription-change-ui-actions.enum';
import { SubscriptionChangeCompleteRequest } from '../../models/subscriptions/subscription-change-complete-request.model';
import { SubscriptionChangeActionResult } from '../../models/subscriptions/subscription-change-action.result.enum';
import { PaymentsRepositoryService } from '../../services/payments-repository.service';
import { map } from 'rxjs/operators';
import { AppMetaDataItemNames } from '../../../../meta-data/app-meta-data.service';

@Component({
  selector: 'app-change-school-subscription-modal',
  templateUrl: './change-school-subscription-modal.component.html',
  styleUrls: ['./change-school-subscription-modal.component.scss']
})
export class ChangeSchoolSubscriptionModalComponent implements OnInit, DwModalHandler {

  constructor(private paymentsRespositoryService: PaymentsRepositoryService,
    private dwMetaDataRoutingService: DwMetaDataRoutingService
  ) { }
  modalConfig: DwModalConfig<SubscriptionChangeStartResult>;
  closeModal: EventEmitter<DwModalResult<any>>;

  changeStartResult: SubscriptionChangeStartResult;

  changeCompleteRequest: SubscriptionChangeCompleteRequest;
  showDowngradeNow: boolean = false;
  downgradeNow: boolean = false;

  requireCreditCard: boolean = false;
  message: DwMessage;

  ngOnInit(): void {
    this.setupModal();
  }

  setupModal() {
    this.changeStartResult = this.modalConfig.data;

    this.changeCompleteRequest = {
      SubscriptionChangeStartResult: this.changeStartResult,
      SubscriptionChangeAction: null,
      DowngradeNow: false
    }

    switch (this.changeStartResult.SubscriptionChangeUIAction) {
      case SubscriptionChangeUIActions.downgradeSubscriptionVerify:
        this.showDowngradeNow = true;

        this.changeCompleteRequest.SubscriptionChangeAction = SubscriptionChangeActionResult.confirmDowngrade;
        break;
      case SubscriptionChangeUIActions.updateSubscriptionNoInvoice:
        this.changeCompleteRequest.SubscriptionChangeAction = SubscriptionChangeActionResult.confirmUpgrade;

        if (this.changeStartResult.RequiresDefaultPayment && !this.changeStartResult.HasDefaultPayment
          && this.changeStartResult.FuturePrice > 0) {
          this.requireCreditCard = true;
        }
        break;

      case SubscriptionChangeUIActions.cancelDowngradeSubscriptionVerify:
        this.changeCompleteRequest.SubscriptionChangeAction = SubscriptionChangeActionResult.cancelFuture;

        break;
    }
  }

  onDowngradeNow(value) {
    this.changeCompleteRequest.DowngradeNow = value;
    // if (value) {
    //   this.changeCompleteRequest.SubscriptionChangeAction = SubscriptionChangeActionResult.confirmDowngradeNow;
    // } else {
    //   this.changeCompleteRequest.SubscriptionChangeAction = SubscriptionChangeActionResult.confirmDowngrade;
    // }
  }

  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult> {
    let result = new DwModalResult();
    result.cancelled = false;

    switch (buttonConfig.command) {
      case DwButtonCommand.ok:
      case DwButtonCommand.saveAndClose:
      case DwButtonCommand.save:
        return this.completeSubscriptionChange();

        break;
      case DwButtonCommand.cancel:
        result.closeModal = true;
        result.cancelled = true;
    }
    return of(result);
  }

  processing = false;

  completeSubscriptionChange(): Observable<DwModalResult> {
    let result = new DwModalResult();
    this.message = null;

    if (this.requireCreditCard) {
      this.message = {
        severity: DwMessageSeverity.error,
        messageBody: 'Please add a credit card to upgrade your subscription.',
      };

      return of(result);
    }

    if (this.changeStartResult.SubscriptionChangeUIAction == SubscriptionChangeUIActions.none) {
      result.closeModal = true;
      result.cancelled = true;

      return of(result);
    }

    return this.paymentsRespositoryService.subscriptionChangeComplete(this.changeCompleteRequest)
      .pipe(map((changeResult) => {
        let result = new DwModalResult();

        if (!changeResult.Success) {
          result.cancelled = true;
          result.closeModal = false;

          this.message = {
            messageBody: changeResult.Message,
            allowClose: true,
            severity: DwMessageSeverity.error
          };
        }
        result.cancelled = false;
        result.closeModal = true;
        result.data = changeResult;

        return result;
      }));
  }

  openCreditCardModal() {
    const modalOptions: Partial<DwModalConfig> = {
      title: 'Add New Card'
    }
    return this.dwMetaDataRoutingService.openAddEditViewModal(
      DwMenuActionType.add, AppMetaDataItemNames.PaymentMethod, null, null, null,
      'school-add-card', modalOptions, true)
      .subscribe(modalResult => {

        if (modalResult.cancelled) {
          return;
        }

        this.requireCreditCard = false;

        this.message = {
          severity: DwMessageSeverity.success,
          messageBody: 'New card added successfully.',
        };
      });
  }

}
